import Styles from '../../../WizardsDrawerV4.module.scss'
import { LevelProps } from '../../../Types'
import { LevelPage } from '../../LevelPage'
import { useForYouItems } from '../../../hooks/useForYouItems'
import { useEffect } from 'react'

export const RecentlyUsed = (props: LevelProps) => {
  const { back } = props
  const { type: forYouType, cards: forYouCards } = useForYouItems()

  useEffect(() => {
    if (forYouType !== 'recently_used' || forYouCards.length === 0) {
      back()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forYouType, forYouCards])

  return (
    <LevelPage
      {...props}
      className={Styles.forYouSection}
      heading="Recently Used"
      cardSize="small"
      cards={forYouCards}
    />
  )
}
